// extracted by mini-css-extract-plugin
export default {"scrollBar":"page-body_scrollBar__zctJs","textAreaScroll":"page-body_textAreaScroll__IlxXX","pageBody":"page-body_pageBody__B5Izg page-body_scrollBar__zctJs"};